import { FC, useCallback, useContext, useMemo, lazy, Suspense } from "react";
import { useHotkeys } from "@blueprintjs/core";
import {
  CommandManagerDispatchContext,
  CommandManagerStateContext,
} from "./CommandManager";

const TimeTrackCreatorDialog = lazy(
  () =>
    import(
      /* webpackChunkName: "TimeTrackCreatorDialog" */ "./TimeTrackCreatorDialog"
    ),
);

export const TimeTrackCreatorHost: FC = function () {
  const dispatch = useContext(CommandManagerDispatchContext);
  const state = useContext(CommandManagerStateContext);
  const handleClose = useCallback(() => {
    dispatch({ type: "CLOSE_TIMETRACK_CREATE" });
  }, []);

  const hotkeys = useMemo(
    () => [
      {
        combo: "Shift+Y",
        global: true,
        preventDefault: true,
        label: "Zeiterfassungseintrag erstellen",
        onKeyDown: () =>
          dispatch({
            type: "OPEN_TIMETRACK_CREATE",
          }),
      },
    ],
    [dispatch],
  );
  useHotkeys(hotkeys);

  if (state.open && state.open.type === "TIMETRACK_CREATE") {
    return (
      <Suspense fallback={null}>
        <TimeTrackCreatorDialog isOpen onClose={handleClose} />
      </Suspense>
    );
  }

  return null;
};
